<template>
  <scoped>
    <VerticalNavigator>
      <Breadcrumb
        v-if="deliverable"
        :links="[{
          title: 'RutSolve',
          routeName: 'index'
        }, {
          title: 'Deliverables',
          routeName: 'deliverables'
        }]"
        :title="deliverable.name"
      />
      <h1>
        Edit Deliverable
      </h1>
      <DeliverableEditor v-model:value="deliverable" />
      <br>
      <Button
        title="Remove"
        @click="confirmRemove = true"
      />
      <Button
        title="Cancel"
        @click="deliverablesRedirect()"
      />
      <Button
        title="Save"
        @click="save()"
      />
    </VerticalNavigator>
    <ConfirmationModal
      v-model:display="confirmRemove"
      :callback="remove"
      message="This action will remove selected deliverable."
      title="Remove Deliverable"
    />
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import DeliverableEditor from "@/components/editors/deliverable.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {useRoute} from "vue-router"
  import {Deliverable as DeliverableClient} from "@/endpoints/rutsolve/gql/resolvers/deliverable"
  import {onBeforeMount, ref} from "vue"
  import {Deliverable} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"
  import Button from "@/components/button.vue"
  import router from "@/router"
  import ConfirmationModal from "@/components/modals/confirmation.vue"

  const error = ref<Error>(null)
  const deliverableClient = new DeliverableClient()
  const deliverable = ref<Deliverable>(null)
  const confirmRemove = ref<boolean>(false)

  onBeforeMount(() => {
    read()
  })

  async function read() {
    try {
      const deliverableID = useRoute().params.deliverableID.toString()
      deliverable.value = await deliverableClient.summary(deliverableID)
    } catch(e) {
      error.value = e
    }
  }

  async function remove() {
    try {
      await deliverableClient.remove(deliverable.value.id)
      deliverablesRedirect()
    } catch(e) {
      error.value = e
    }
  }

  async function save() {
    try {
      await deliverableClient.update(deliverable.value)
      deliverablesRedirect()
    } catch(e) {
      error.value = e
    }
  }

  function deliverablesRedirect() {
    router.push({
      name: "deliverables"
    })
  }
</script>
